// removed by extract-text-webpack-plugin
module.exports = {"app-footer":"theme--app-footer--aSmZ5fOB","appFooter":"theme--app-footer--aSmZ5fOB"};


//////////////////
// WEBPACK FOOTER
// ./src/modules/home/AppFooter/theme.scss
// module id = 1183
// module chunks = 0